import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogueHandler, AddSignerDialogueHandler } from './types';
import AddSignerContext from './AddSignerContext';

const { ConfirmationDialogue } = vp;

type AddSignerDialogueProps = {
  handleDialogue: DialogueHandler<AddSignerDialogueHandler>;
};

type FC = FunctionComponent<AddSignerDialogueProps>;

const AddSignerDialogue: FC = ({ handleDialogue }: AddSignerDialogueProps) => {
  const { t } = useTranslation('translations', { keyPrefix: 'AddSignerDialogue' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  const { showAddSignerFailError } = useContext(AddSignerContext);

  return useMemo(
    () => (
      <div>
        {/* Add Signer Error */}
        <ConfirmationDialogue
          isVisible={showAddSignerFailError}
          title={t('title', { defaultValue: 'Error! The signer was not added.' })}
          status="error"
          subTitle={t('subTitle', { defaultValue: 'Please provide valid address.' })}
          confirm={{
            label: tGlobal('Buttons.back'),
            action: () => handleDialogue({ type: 'error', state: 'confirm' }),
          }}
        />
      </div>
    ),
    [showAddSignerFailError, t, tGlobal],
  );
};

export default AddSignerDialogue;
